import styled, { css } from 'styled-components';
import { Modal as ModalComponent } from 'src/components';
import { PronunciationViewWrapper } from '../PronunciationViews';
import { DebugPanel } from '../PronunciationDebugPanel/styles';

export const Modal = styled(ModalComponent)(
  ({ theme }) => css`
    .reactModalContent {
      max-width: ${theme.sz.lg};
    }
  `,
);

export const ModalContent = styled.div(
  ({ theme }) => css`
    ${PronunciationViewWrapper} {
      min-height: min(90dvh, ${theme.sz.ml});
      align-items: center;

      @media (max-height: ${theme.sz.md}) {
        padding-bottom: ${theme.sz.s4};
      }

      @media (max-width: ${theme.sz.md}) {
        padding: ${theme.sz.s4};
        min-height: 100dvh;
        align-items: start;
      }
    }

    ${DebugPanel} {
      top: ${theme.sz.s12};
    }
  `,
);

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
  `,
);
